import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EmbeddedViewRef,
  inject, OnDestroy,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

@Component({
  selector: 'app-view-header-portal',
  standalone: true,
  templateUrl: './view-header-portal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewHeaderPortalComponent implements AfterViewInit, OnDestroy {

  @ViewChild('viewHeader') private templateRef: TemplateRef<any> | undefined;
  private vcr: ViewContainerRef = inject(ViewContainerRef);
  private viewRef: EmbeddedViewRef<{}> | undefined;
  private disposeFn: (() => void) | undefined;

  ngAfterViewInit() {
    if (this.templateRef) {
      this.viewRef = this.vcr.createEmbeddedView(this.templateRef);
    }

    const outlet = document.querySelector('#view-header-portal');

    if (outlet) {
      this.viewRef?.rootNodes?.forEach(node => {
        outlet.appendChild(node);
      });
    }

    this.disposeFn = () => {
    };
  }

  ngOnDestroy() {
    if (this.viewRef) {
      const index = this.vcr.indexOf(this.viewRef);
      if (index !== -1) {
        this.vcr.remove(index);
      }
    }
  }

}
